import grpcClient from '~/grpc/grpc-client'
import { commonMetaData } from '@/store/_helpers/common-helper'
import { GetMyRatingCommentsRequest } from '@/stub/apigateway/profile/rating_pb'
import { RatingService } from '@/stub/apigateway/profile/rating_pb_service'

// initial state
const initialState = () => ({
  ratingCommentsList: []
})

export const state = () => initialState()

// getters
export const getters = {}

// actions
export const actions = {
  async fetchMyRatingComments({ commit, rootState }, { page, limit }) {
    const metadata = commonMetaData(rootState)
    const request = new GetMyRatingCommentsRequest()
    request.setPage(page)
    request.setLimit(limit)
    const response = await grpcClient({
      method: RatingService.GetMyRatingComments,
      request,
      metadata
    })
    commit('RECEIVE_RATING_COMMENTS', response)
    return response.ratingCommentsList.length < limit
  }
}

// mutations
export const mutations = {
  RECEIVE_RATING_COMMENTS(state, data) {
    state.ratingCommentsList.splice(state.ratingCommentsList.length, 0, ...data.ratingCommentsList)
  }
}
